package com.example.mystybag.sharedmodels.project.requestModels.merchant

import com.example.mystybag.sharedmodels.AllCommands.UPDATE_MERCHANT_LOCATION
import com.example.mystybag.sharedmodels.base.BaseRequestModel
import kotlinx.serialization.Serializable

/**
 * Request model for updating a merchant location.
 * Mirrors [CreateMerchantLocationRequestModel] so all fields can be edited.
 * For menu photos: existing URLs to keep + new URLs to add (server replaces any not in keep list).
 */
@Serializable
data class UpdateMerchantLocationRequestModel(
    val locationId: Long,
    val businessCategoryId: Long,
    val storeName: String,
    val storeAddress: String,
    val cityId: Long,
    val storePhoneNumber: String,
    val dialCode: String,
    val packaging: String = "",
    val additionalPickupInstructions: String = "",
    val surpriseBagContainsBuffetFood: Boolean = false,
    val latitude: Double,
    val longitude: Double,
    /** Root-level products (name + grams). Replaces the location's catalog root products. */
    val products: List<com.example.mystybag.sharedmodels.project.responseModels.merchant.LocationProductInput> = emptyList(),
    val coverPhotoUrl: String? = null,
    val menuPhotoUrlsToKeep: List<String> = emptyList(),
    val menuPhotoUrlsToAdd: List<String> = emptyList()
) : BaseRequestModel(api = UPDATE_MERCHANT_LOCATION)
